import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ROUTES } from './constants';
import Spinner from './components/Spinner/Spinner';

// Lazy load the container components
const Auth = lazy(() => import('./containers/Auth'));
const DashboardPage = lazy(() => import('./containers/Dashboard'));
const Form = lazy(() => import('./containers/Form'));
const Share = lazy(() => import('./containers/Share'));

// Optional: A nice loading component while the chunk downloads
const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spinner color="#AE007B" />
  </div>
);

function App() {
  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path={ROUTES.AUTH.CHILDREN} element={<Auth />} />
          <Route path={ROUTES.DASHBOARD.CHILDREN} element={<DashboardPage />} />
          <Route path={ROUTES.FORMS.CHILDREN} element={<Form />} />
          <Route path={ROUTES.SHARES.CHILDREN} element={<Share />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </>
  );
}

export default App;

// /* eslint-disable */
// import React,{useState} from 'react';
// import { ToastContainer } from 'react-toastify';
// import Router from './components/Router';
// import Auth from './containers/Auth';
// import Form from './containers/Form';
// import Share from './containers/Share';

// import DashboardPage from './containers/Dashboard';
// import { ROUTES } from './constants';

// function App() {
//   return (<>
//       <Router>
//         <Auth path={ROUTES.AUTH.CHILDREN} />
//         <DashboardPage path={ROUTES.DASHBOARD.CHILDREN} />
//         <Form path={ROUTES.FORMS.CHILDREN} />
//         <Share path={ROUTES.SHARES.CHILDREN} />
//       </Router>
//       <ToastContainer />
//  </> );
// }

// export default App;
